export default __webpack_public_path__ + "static/media/content2.b402f960.png";